module.exports = __webpack_public_path__ + "static/media/bgRankingMobile.016911c0.jpg";